import React, { useState, useEffect } from "react";
import styles from "./styles.module.css";
import cx from "classnames";
import { Formik, Form, Field } from "formik";
import axios from "axios";
import Fb from "../footer/icons/fb";
import Tg from "../footer/icons/telegram";
import Ig from "../footer/icons/instagram";
import Tw from "../footer/icons/twitter";
import addToMailchimp from "gatsby-plugin-mailchimp";
import SvgTelegram from "./icons/telegram";
import { sendFormDataToWebjack } from "../../../intergrations/web-jack";

const Success = () => {
  return (
    <div className={cx(styles.successRoot)}>
      <div className={styles.textContainer}>
        <h4 className={styles.title}>Спасибо!</h4>
        <p className={styles.desc}>
          Ваша заявка принята. <br />
          Мы свяжемся с вами в ближайшее время.
        </p>
      </div>
      <div className={styles.bottom}>
        <p className={styles.successText}>А пока подпишитесь на нас везде:</p>
        <div className={styles.social}>
          <div className={styles.icon}>
            <a
              href="https://www.instagram.com/guidedao.xyz/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Ig />
            </a>
          </div>

          <div className={styles.icon}>
            <a
              href="https://t.me/deepdepeg"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Tg />
            </a>
          </div>

          <div className={styles.icon}>
            <a
              href="https://twitter.com/guidedao"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Tw />
            </a>
          </div>

          <div className={styles.icon}>
            <a
              href="https://www.facebook.com/guidedao.xyz"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Fb />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const Consultation = ({ title }) => {
  const [isFormSent, setFormState] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentUtm, setUtm] = useState("Нет меток");

  useEffect(() => {
    setUtm(localStorage.getItem("currentUtm"));
  }, []);

  const size = useWindowSize().width;
  const deviseForOrder = isDesktop();
  function isDesktop() {
    if (size > 1024) {
      return "С десктопа";
    } else {
      return "С мобильного";
    }
  }

  function useWindowSize() {
    const isClient = typeof window === "object";
    function getSize() {
      return {
        width: isClient ? window.innerWidth : undefined,
        height: isClient ? window.innerHeight : undefined,
      };
    }
    const [windowSize, setWindowSize] = useState(getSize);

    useEffect(() => {
      if (!isClient) {
        return false;
      }

      function handleResize() {
        setWindowSize(getSize());
      }
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowSize;
  }

  const inputName = React.useRef(null);
  const inputPhone = React.useRef(null);
  const inputEmail = React.useRef(null);
  const nameOfCourse = title;
  useEffect(() => {
    inputEmail.current.addEventListener("change", function() {
      localStorage.setItem("nameOfCourse", nameOfCourse);
      localStorage.setItem("nameOfStudent", inputName.current.value);
      localStorage.setItem("phone", inputPhone.current.value);
      localStorage.setItem("email", inputEmail.current.value);
    });
  }, [inputEmail]);

  return (
    <div className={styles.container}>
      {isFormSent && <Success />}

      <div
        className={[
          styles.desktopDisplayNone,
          isFormSent ? styles.hidden : null,
        ].join(" ")}
      >
        <div>
          <div className={styles.textContainer}>
            <h4 className={styles.title}>
              {isFormSent ? "Спасибо!" : "Заказать консультацию"}
            </h4>
            <p className={styles.desc}>
              {isFormSent
                ? "Ваша заявка принята. Мы свяжемся с вами в ближайшее время"
                : "На все ответим, обо всем расскажем"}
            </p>
          </div>
        </div>
      </div>

      <Formik
        initialValues={{
          name: "",
          phone: "",
          email: "",
        }}
        validate={(values) => {
          const errors = {};
          Object.keys(values).forEach((name) => {
            if (
              name === "email" &&
              values[name] !== "" &&
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values[name])
            ) {
              return (errors[name] = "Неверный email");
            }
          });
          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          sendFormDataToWebjack({
            values,
            webhook: "cac18a6fa4334fe883fdc58d08f06c8a",
            params: [
              "ysclid",
              "utm_source",
              "utm_medium",
              "utm_campaign",
              "utm_campaign",
              "utm_source",
              "utm_medium",
              "utm_content",
              "name",
              "phone",
              "email",
            ],
          });

          setIsLoading(true);
          addToMailchimp(values.email);
          {
            const payload = {
              title: `${title}`,
              name: `<b>Имя:</b> ${values.name}`,
              tel: `<b>Тел:</b> ${values.phone}`,
              email: `<b>Email:</b> ${values.email}`,
              utm: `<b>utm-метка</b> ${currentUtm}`,
              isDesktop: `<b>Откуда заявка</b>: ${deviseForOrder}`,
            };
            axios({
              url: "/api/newConsultation.js",
              method: "POST",
              data: payload,
              headers: {
                "content-type": "application/json",
              },
            })
              .then(() => {
                setIsLoading(true);
                setSubmitting(false);
                setFormState(true);
              })
              .catch((err) => {
                setIsLoading(false);
                console.error(err);
                setSubmitting(false);
                alert("Ошибка при отправке формы. Повторите попытку позднее!");
              });
          }
          setSubmitting(false);
        }}
        render={({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form
            name="ConsultationForm"
            autoComplete="off"
            onSubmit={handleSubmit}
            className={cx("consultation", {
              [styles.hidden]: isFormSent === true,
            })}
          >
            <div className={styles.row}>
              <div className={styles.field}>
                <Field
                  type="text"
                  name="name"
                  className={styles.input}
                  value={values.name}
                  innerRef={inputName}
                  onChange={handleChange}
                  required
                />
                <p className={styles.inputTitle}>Имя</p>
              </div>
            </div>

            <div className={styles.row}>
              <div className={styles.field}>
                <Field
                  type="text"
                  name="phone"
                  innerRef={inputPhone}
                  className={styles.input}
                  value={values.phone}
                  onChange={handleChange}
                  required
                />
                <p className={styles.inputTitle}>Телефон / телеграм</p>
              </div>

              <div className={styles.field}>
                {errors.email && touched.email ? (
                  <div className={styles.errorMsg}>{errors.email}</div>
                ) : null}
                <Field
                  type="text"
                  name="email"
                  innerRef={inputEmail}
                  className={styles.input}
                  value={values.email}
                  onChange={handleChange}
                  required
                />
                <p className={styles.inputTitle}>Email</p>
              </div>
            </div>

            <button
              className={cx(styles.btnSubmit, "btnSubmitForSeo", {
                [styles.opacity]:
                  values.name !== "" &&
                  !errors.name &&
                  !errors.phone &&
                  !errors.email,
              })}
              type="submit"
              disabled={isSubmitting}
            >
              {isLoading
                ? "Отправляем…"
                : size > 768
                ? "Заказать консультацию"
                : "Отправить заявку"}
            </button>
            <div className={styles.personalInfo}>
              Или свяжитесь с{" "}
              <a
                href="https://t.me/guidedao_xyz"
                target="_blank"
                className={styles.linkToPrivacy}
              >
                консультантом в телеграме
              </a>{" "}
              <a href="https://t.me/guidedao_xyz" target="_blank">
                <SvgTelegram />
              </a>
            </div>
          </Form>
        )}
      />
    </div>
  );
};

export default Consultation;
